import React from 'react';
import styles from './Alert.module.css'; // Thêm style tùy ý

const Alert = ({ type, message, onClose }) => {
    if (!message) return null;
    return (
        <div className={`${styles.alert} ${styles[type]}`}>
            <span>{message}</span>
            <button onClick={onClose} className={styles.closeBtn}>&times;</button>
        </div>
    );
};
export default Alert;